import { Component } from '@angular/core';
import { MemberAd } from "./DTOs/member-ad";
import { merge, Observable } from "rxjs";
import { ToastNotificationService } from "../core/toast-notification.service";
import { UIBlockingService } from "../core/ui-blocking.service";
import { MemberAdService } from "./member-ad.service";
import { PendingDiscountsDtRetInfo } from "../member-discount/DTOs/pending-discounts-dt-ret-info";
import { MemberAdsDtRetInfo } from "./DTOs/member-ad-dt-ret-info";
import { GetPendingDiscountsListRequest } from "../member-discount/DTOs/get-pending-discounts-list-request";
import { GetMemberAdsListRequest } from "./DTOs/get-member-ad-list-request";
import { CommonLibrary } from "../core/common-library";

@Component({
    selector: 'app-pending-ads-list',
    templateUrl: './pending-ads-list.component.html',
    providers: [UIBlockingService]

})
export class PendingAdsListComponent {

    constructor(private memberAdService: MemberAdService,
        private notificationService: ToastNotificationService,
        private blockUI: UIBlockingService) { }

    ads: MemberAd[] = [];
    totalAds = 0;
    filteredAds = 0;
    pageNum = 1;
    itemsPerPage = 10;
    initialLoad = true;
    filtersChanged = false;
    searchText = "";
    statusSearch = { display: "Pending", value: 0 };

    sortType = 5;
    keywordSearches: string[] = [];

    ngOnInit() {
        var observablesMerged = merge(this.getPendingAdsObservable());
        this.blockUI.start();
        observablesMerged.subscribe(
            {
                next: (data) => {
                    this.ads = data.data;
                    this.totalAds = data.recordsTotal;
                    this.filteredAds = data.recordsFiltered;
                    this.initialLoad = false;
                },
                error: (err) => {
                    this.notificationService.error(err.error.message);
                    this.blockUI.stop();
                    console.log(err)
                },
                complete: () => {
                    this.blockUI.stop();
                    if (this.ads.length == 0) {
                        console.log(" no ads found ")
                    }
                }
            });
    }

    getPendingAds() {
        this.blockUI.start();
        this.getPendingAdsObservable()
            .subscribe(
                {
                    next: (data) => {
                        this.ads = data.data;
                        this.totalAds = data.recordsTotal;
                        this.filteredAds = data.recordsFiltered;
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                        if (this.ads.length == 0) {
                            console.log(" no Discounts found ")
                        }
                    }
                });
    }

    getPendingAdsObservable(): Observable<MemberAdsDtRetInfo> {
        var req = this.createSearchRequest();
        return this.memberAdService
            .getPendingAdList(req);
    }

    createSearchRequest(): GetMemberAdsListRequest {
        var req = new GetMemberAdsListRequest();

        if (this.filtersChanged)
            this.pageNum = 1;

        req.PageNumber = this.pageNum - 1; //to get the 0-indexed number
        req.ItemsPerPage = this.itemsPerPage;

        req.KeywordSearches = this.keywordSearches;
        req.Sorting = this.sortType;

        req.StatusSearch = this.statusSearch.value;

        this.filtersChanged = false;
        return req;
    }

    get currentPageNum() { return this.pageNum };
    set currentPageNum(page: number) {
        this.pageNum = page;
        if (!this.initialLoad)
            this.getPendingAds();
    }

    get itemStart() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + 1;
    }

    get itemEnd() {
        return ((this.currentPageNum - 1) * this.itemsPerPage) + this.ads.length;
    }

    clearSearch() {
        this.searchText = "";
        this.sortType = 1;
        this.keywordSearches = [];
        this.filtersChanged = true;
        this.statusSearch = { display: "Pending", value: 0 };
        this.getPendingAds();
    }

    hitSearchBtn() {
        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingAds();
    }

    removeSearchTerm(term: string) {
        var index = this.keywordSearches.indexOf(term);
        if (index != -1) {
            this.keywordSearches.splice(index, 1);
            this.filtersChanged = true;
        }
        this.getPendingAds();
    }

    enterSearchTerm(event: any) {
        if (event.keyCode != 13)//13 is enter, 32 is space
            return;

        this.searchText.trim().split(' ').forEach((term) => this.keywordSearches.push(term));
        this.searchText = '';
        this.filtersChanged = true;
        this.getPendingAds();
        return;
    }

    changeSortType(column: number) {
        switch (column) {
            case 1:
                this.sortType = (this.sortType == 1) ? 2 : 1;
                break;
                case 2:
                    this.sortType = (this.sortType == 7) ? 8 : 7;
                    break;
            case 3:
                this.sortType = (this.sortType == 3) ? 4 : 3;
                break;
            case 4:
                this.sortType = (this.sortType == 5) ? 6 : 5;
                break;
            case 5:
                this.sortType = (this.sortType == 9) ? 10 : 9;
                break;
            default:
                break;
        }
        this.getPendingAds();
    }

    changeStatusSearch(toChange: number) {
        if (this.statusSearch.value == toChange)
            return;

        this.filtersChanged = true;
        switch (toChange) {
            case -1:
                this.statusSearch = { display: "All", value: -1 };
                break;
            case 0:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
            case 1:
                this.statusSearch = { display: "Approved", value: 1 };
                break;
            case 2:
                this.statusSearch = { display: "Denied", value: 2 };
                break;
            default:
                this.statusSearch = { display: "Pending", value: 0 };
                break;
        }
        this.getPendingAds();
    }

    downloadAdImage(ad) {
        this.memberAdService.getAdImageUrl(ad.adId)
            .subscribe(
                {
                    next: (data) => {
                        CommonLibrary.downloadImageByUrl(data, ad.memberCompany + '_Ad_' + CommonLibrary.formatDateIntoString(ad.submissionDate))
                    },
                    error: (err) => {
                        this.notificationService.error(err.error.message);
                        this.blockUI.stop();
                        console.log(err)
                    },
                    complete: () => {
                        this.blockUI.stop();
                        if (this.ads.length == 0) {
                            console.log(" no Discounts found ")
                        }
                    }
                });

        
    }

    protected readonly CommonLibrary = CommonLibrary;
}
